export default {"src":"/_next/static/media/error.61b95dfb.svg","height":54,"width":55};